/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class DisableAccountMultiError extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore, response }: TypeProps = this.props;
    // const errorResponse: Object = actionDrawerStore.errorResponse;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:trading_accounts.disable_failed')}</h3>
            {response && <p>{response.message}</p>}
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
